// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyUrlButton_copyButton__GNF5n"};